export default __webpack_public_path__ + "static/media/ecommerce1.95f98237.png";